import React, { useState, useEffect } from 'react'
import Select from "react-select";
import { Container, Draggable } from '@smooth-dnd/react'
import { _Api, graphqlPostapp } from "../api/_call";
import RightArrow from "../common/icons/right-arrow";
import { Link } from 'react-router-dom'
import { loading, Updateloading } from '../common/helpers/toastify';
import { arrayMoveImmutable } from 'array-move'
import { useTranslation } from 'react-i18next';
const SettingLanguage = () => {
  const { t } = useTranslation();
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL
  const [languagesgraph, setLanguagesgraph] = useState([])
  const [completeDataObject, setCompliteDataObject] = useState()
  const onChangeValueUpdate = (keyName, value) => {
    setCompliteDataObject(prevState => ({
      ...prevState,
      [keyName]: value
    }));
  }
  const languagesview = async () => {
    try {
      let postdata = {}
      let res = await _Api(postdata, `api/v1/App/profile/languages-view`)
      if (res?.code === 200) {
        setCompliteDataObject(res?.data)
      }
    }
    catch (err) {
      console.log(err, "err")
    }
  }
  const getlanguagesList = async () => {
    try {
      const postdata = `{
        languages{
            name
            shortcode
            flag
            value
        }
     }`
      let responce = await graphqlPostapp(postdata);
      setLanguagesgraph(responce.data?.languages);

    } catch (err) {
      console.log(err, "err");

    }
  };
  useEffect(() => {
    languagesview()
    getlanguagesList()
  }, [])
  const addEventList = () => {
    let newValues_ = { ...completeDataObject };
    let newValues = [...newValues_?.language_list];
    newValues.push({
      "name": "",
      "shortcode": "",
      "flag": ""
    });
    newValues_.language_list = newValues;
    setCompliteDataObject(newValues_);

  };

  const handleRemoveElement = (indexToRemove) => {
    let newValues_ = { ...completeDataObject };
    let newValues = [...newValues_?.language_list];
    let updatedArray = newValues.filter((_, index) => index !== indexToRemove);
    newValues_.language_list = updatedArray;
    setCompliteDataObject(newValues_);
  };
  const handleSelectChange = (index, value) => {
    let newValues_ = { ...completeDataObject };
    let newValues = [...newValues_?.language_list];
    newValues[index] = value;
    newValues_.language_list = newValues;
    setCompliteDataObject(newValues_);
  };
  const editlanguage = async () => {
    let language_list = []
    let finaldata = { ...completeDataObject }
    finaldata?.language_list.forEach((element) => {
      language_list.push(element.value)
    })
    let GetloadingID = loading();
    try {
      let postdata = {
        "Default_language": completeDataObject?.Default_language?.value,
        "language_list": language_list
      }
      let res = await _Api(postdata, `api/v1/App/profile/languages-edit`)
      if (res.code === 200) {
        Updateloading(t, GetloadingID, (res?.message));
        languagesview()
      } else {
        Updateloading(t, GetloadingID, (res.errors), 'error');
      }

    }
    catch (err) {
      console.log(err, "err")
    }
  }
  const onMoveContent = async ({ removedIndex, addedIndex }) => {
    const newDataSelect = arrayMoveImmutable(completeDataObject?.language_list, removedIndex, addedIndex)
    let language_list = []
    newDataSelect.forEach((element) => {
      language_list.push(element.value)
    })
    let GetloadingID = loading();
    try {
      let postdata = {
        "Default_language": completeDataObject?.Default_language?.value,
        "language_list": language_list
      }
      let res = await _Api(postdata, `api/v1/App/profile/languages-edit`)
      if (res.code === 200) {
        Updateloading(t, GetloadingID, (res?.message));
        languagesview()
      } else {
        Updateloading(t, GetloadingID, (res.errors), 'error');
      }

    } catch (err) {
      console.log(err, "err")
    }

  }
  return (
    <div className="main-content-wrapper-body">
      <div className="main-content-wrapper-body-top-bar d-flex align-items-center justify-content-between">
        <div className="main-content-wrapper-body-top-bar-left">
          <h1 className="main-content-wrapper-body-top-bar-left-heading fw-semibold mb-0">
            <Link className="text-decoration-none" to="/app/admin/settings">{t("Setting")}</Link>  <RightArrow /> <span className="">{t("Language")}</span></h1>
        </div>
        <div className="main-content-wrapper-body-top-bar-right d-flex align-items-center"
          onClick={() => editlanguage()}>
          <button className="square-btn"><img src={base_assets + "images/icons/white-save.png"} alt="" /></button>
        </div>
      </div>
      <div className="admin-main-card">
        <div className="row">
          <div className="col-md-4">
            <div className="row">
              <div className="col-md-12">
                <div className="v3-input-group">
                  <label className="v3-input-group-label">
                    {t("Default language")}
                  </label>
                  <Select
                    className="select-set select w-100 p-0"
                    placeholder=""
                    options={completeDataObject?.language_list}
                    value={completeDataObject?.Default_language}
                    onChange={(e) => {
                      onChangeValueUpdate("Default_language", e)
                    }}
                    classNamePrefix="common-select"
                    isSearchable={false}
                    getOptionLabel={(e) => (
                      <div className="common-select-icon">
                        <img src={base_assets + "images/flags/" + e.flag} alt="" /><span>{e.shortcode} - {e.name}</span>
                      </div>
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 ms-4">
            <div className="row">
              <div className="col-md-12">
                <div className="v3-input-group">
                  <label className="v3-input-group-label">{t("All languages")}</label>
                  <Container lockAxis="y" dragHandleSelector='.drag-btn'
                    onDrop={onMoveContent}
                  >
                    {completeDataObject?.language_list?.length ? completeDataObject?.language_list.map((result, key) => {
                      const selectedLanguages = completeDataObject.language_list.map(lang => lang.value);
                      const availableOptions = languagesgraph.filter(lang =>
                        !selectedLanguages.includes(lang.value) || lang.value === result.value
                      );

                      return (
                        <Draggable key={key}>
                          <div className="row d-flex align-items-center mb-3">
                            <div className="w-auto pe-0 drag-btn">
                              <img
                                className="drag-btn-icon"
                                src={base_assets + 'images/admin/icons/drag-icon.png'} alt=""
                              />
                            </div>
                            <div className="col-md-8">
                              <Select
                                className="select-set select w-100 p-0"
                                placeholder=""
                                options={availableOptions}
                                value={result}
                                onChange={(e) =>
                                  handleSelectChange(
                                    key,
                                    e
                                  )}
                                classNamePrefix="common-select"
                                isSearchable={false}
                                getOptionLabel={(e) => (
                                  <div className="common-select-icon">
                                    <img src={base_assets + "images/flags/" + e.flag} alt="" /><span>{e.shortcode} - {e.name}</span>
                                  </div>
                                )}
                              />
                            </div>
                            {key !== 0 ?
                              <div className="w-auto px-0"
                                onClick={() => handleRemoveElement(key)}>
                                <img src={base_assets + 'images/icons/minus-detail.png'} alt="" />
                              </div> : ""
                            }

                          </div>
                        </Draggable>
                      )
                    }) : ""}
                  </Container>

                  <button className="border-none main-green-bg text-white rounded-1 py-1 px-2 mt-4 d-block fs-14"
                    onClick={() => addEventList()}>
                    <img className='me-1' src={base_assets + "images/icons/add-icon-white.png"} alt="" /> {t("Add More Languages")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SettingLanguage
